import { WebPortalService } from "../resource";

const CapacityModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    }
  },
  actions: {
    async listData({ commit }) {
      try {
        const data = await WebPortalService.CapacityListV4();
        commit("SET_DATA", data.data.Data == null ? [] : data.data.Data);
      } catch {
        commit("SET_DATA", []);
      }
    }
  },
  getters: {
    getData(state) {
      return state.data;
    }
  }
};

export default CapacityModule;
